var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-codeflask",style:('height:'+(_vm.input.height||300)+'px'),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }